export default __webpack_public_path__ + "static/media/xplor.cda0c1ae.png";